module.exports = __webpack_public_path__ + "static/people_pop4-e34d66a3d2a89ee0a603b09bec177704.png";